import { render, staticRenderFns } from "./ExtraFacilityPopup.vue?vue&type=template&id=f413f820"
import script from "./ExtraFacilityPopup.vue?vue&type=script&lang=js"
export * from "./ExtraFacilityPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports